export enum Category {
  /**
   * Eigentumswohnung, Condominium
   */
  ETW = "ETW",
  /**
   * Einfamilienhaus, SingleFamilyHouse
   */
  EFH = "EFH",
  /**
   * Mehrfamilienhaus, MultiFamilyDwelling
   */
  MFH = "MFH",
  /***
   * Grundstück, UndevelopedPlot
   */
  GRD = "GRD",
}
